import styled from '@emotion/styled'
import {
  Button,
  MODAL_SIZE_SM,
  Modal,
  ModalHead,
  ModalBody,
  ModalFoot,
  Checkbox
} from 'mailup-web-components'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import { useRecoilCallback, useRecoilState, useRecoilValue } from 'recoil'
import { startCallback } from '../recoil/callbacks/callbacks'
import { modalWarningAliasState, pageDataState } from '../recoil/states/state'

const StyledButtonLeft = styled(Button)`
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
`

const StyledButtonRight = styled(Button)`
  margin-left: 0 !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
`

const ModalWarningAlias = () => {
  const intl = useIntl()

  const { idSms, idInvio } = useParams()
  const { RecipientsReachedWithoutAlias } = useRecoilValue(pageDataState)
  const [{ show, sendingType }, setModalWarningAliasState] = useRecoilState(
    modalWarningAliasState
  )
  const [confirm, setConfirm] = useState(false)
  const start = useRecoilCallback(startCallback, [])

  const handleConfirm = () => {
    start(idInvio, idSms, sendingType)
  }

  const onClose = () => {
    setModalWarningAliasState(prev => ({
      ...prev,
      show: false
    }))
  }

  const onChangeConfirm = () => {
    setConfirm(!confirm)
  }

  return (
    <Modal
      data-mu-test='modal-warning-alias'
      show={show}
      onClose={onClose}
      showClose
      closeOnOverlayClick
      // size={MODAL_SIZE_SM}
    >
      <ModalHead
        title={intl.formatMessage(
          {
            id: 'Load.WarningAlias.NewTitleModalNew'
          },
          {
            X: RecipientsReachedWithoutAlias
          }
        )}
      />
      <ModalBody>
        <p>
          {intl.formatMessage(
            {
              id: 'Load.WarningAlias.DescriptionModalNew'
            },
            {
              strong: str => <strong>{str}</strong>
            }
          )}
        </p>
      </ModalBody>
      <ModalFoot>
        <StyledButtonLeft
          kind='secondary'
          data-mu-test='button-ConfirmModal'
          onClick={onChangeConfirm}
        >
          <Checkbox
            label={intl.formatMessage({ id: 'Load.WarningAlias.ConfirmModal' })}
            checked={confirm}
          />
        </StyledButtonLeft>
        <StyledButtonRight
          kind='primary'
          onClick={() => handleConfirm()}
          data-mu-test='button-confirm'
          disabled={!confirm}
        >
          {intl.formatMessage({ id: 'Load.WarningAlias.GoOn' })}
        </StyledButtonRight>
      </ModalFoot>
    </Modal>
  )
}

export default ModalWarningAlias
